import { Component } from '@angular/core';

@Component({
    selector: 'app-create-account',
    templateUrl: './create-account.component.html',
    styleUrls: ['./create-account.component.scss'],
    standalone: true
})
export class CreateAccountComponent {

}
